<template>
  <div class="fts-tab" v-show='isActive'>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Tab'
    }
  },
  data:() => ({
    isActive: true
  })
}
</script>